var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M5.2 10v10c0 .7.6 1.2 1.2 1.2h10c.7 0 1.2-.6 1.2-1.2V10h1.5v10c0 1.5-1.2 2.8-2.8 2.8h-10c-1.5 0-2.8-1.2-2.8-2.8V10h1.7z",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M1.7 6c0-1.5 1.2-2.8 2.8-2.8h14c1.5 0 2.8 1.2 2.8 2.8v2c0 1.5-1.2 2.8-2.8 2.8h-14C3 10.8 1.7 9.5 1.7 8V6zm2.8-1.2c-.7 0-1.3.5-1.3 1.2v2c0 .7.6 1.2 1.3 1.2h14c.7 0 1.2-.6 1.2-1.2V6c0-.7-.6-1.2-1.2-1.2h-14z",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M10.1 3.4c-.2.3-.7.4-1 .2-.3-.2-.4-.7-.2-1l.6.4-.6-.4v-.1s.1-.1.1-.2c.1-.1.3-.3.5-.4.4-.3 1.1-.6 1.9-.6s1.5.3 1.9.6c.2.2.4.3.5.4.2.1.2.2.3.2v.1l-.6.4.6-.4c.2.3.1.8-.2 1-.3.2-.8.1-1-.2m0 0s-.1 0 0 0l-.3-.3c-.2-.2-.6-.3-1.1-.3-.5 0-.8.2-1.1.3-.1.1-.2.2-.3.2 0 0 0 .1-.1.1",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/Trashcan.2e90d985d27b599b515ee48c3530dcc3.svg";
export { ForwardRef as ReactComponent };